import React from 'react'

const useHasMounted = () => {
  const [isJsEnabled, setIsJsEnabled] = React.useState(false)
  React.useLayoutEffect(() => {
    setIsJsEnabled(true)
  }, [])
  return isJsEnabled
}

export default useHasMounted
